import type { ConstructorType } from '@/types'

export type TmBaseEventConstructor<T extends TmBaseEvent> = ConstructorType<T> & { readonly id: string }

export abstract class TmBaseEvent<T = void> extends CustomEvent<T> {
  public static readonly id: string

  protected constructor(eventId: string, detail?: T) {
    super(eventId, detail ? { detail } : undefined)
  }

  public get id(): string {
    return (this.constructor as typeof TmBaseEvent).id
  }
}
